

let stat = {

    Moment : require('moment'),
    QueryYear : null,

    Init : () => {
        stat.Actions();
        stat.GetQueryYear();
        stat.QuotationChart();
        stat.InvoiceMonth();
        stat.ProjectChart();
        stat.InvoiceChart();
    },

    Actions : () => {

        Jd.off('click', '.dashboard-stat-nav-item').on('click', '.dashboard-stat-nav-item', function(){

            let nav_item = J(this).attr('data-stat-nav');
            J('.dashboard-stat-nav-item').removeClass('dashboard-stat-nav-item-selected');
            J(this).addClass('dashboard-stat-nav-item-selected');

            J('.dashboard-container').addClass('dashboard-container-hidden');
            J('.dashboard-container[data-stat-nav="'+nav_item+'"]').removeClass('dashboard-container-hidden');

            if (nav_item === 'stat-projects') {

                var $table = J('#dashboard_project_table_stat_percent');
                var rows = $table.find('tr.project-table-stat-percent').get();

                rows.sort(function(a, b) {

                    var keyA = parseInt(J(a).attr('data-percent'));
                    var keyB = parseInt(J(b).attr('data-percent'));

                    if (keyA < keyB) {
                        return 1;
                    }
                    if (keyA > keyB) {
                        return -1;
                    }
                    return 0;
                });

                J.each(rows, function(index, row) {
                    $table.children('tbody').append(row);
                });
            }
        });
    },

    GetQueryYear : () => {
        let uri = window.location.href;
        if (uri.indexOf('?query_year=') != -1) {
            stat.QueryYear = uri.split('?query_year=')[1];
        } else {
            stat.QueryYear = stat.Moment().format('YYYY');
        }
        if (J('.year-nav-item-selected').length) {
            stat.QueryYear = J('.year-nav-item-selected').parent().find('input[name="query_year"]').val();
        }
    },

    MonthLabel : () => {
        return [
            'Janv',
            'Fev',
            'Mars',
            'Avr',
            'Mai',
            'Juin',
            'Juil',
            'Août',
            'Sept',
            'Oct',
            'Nov',
            'Déc'
        ]
    },

    ProjectChart : () => {

        if (J('#project_chart').length) {

            const labels        = stat.MonthLabel();
            let defaultDatas    = [2, 10, 60, 30, 20, 10, 80, 30, 50, 90, 60, 20];

            stat.Ajax('/admin/ajax/stat/projects?year='+stat.QueryYear, {}, function(results){

                const data = {
                    labels: labels,
                    datasets: [{
                        label: 'Nouveaux Projets',
                        backgroundColor: 'rgba(54, 162, 235, 0.4)',
                        borderColor: 'rgb(54, 162, 235)',
                        data: (results ? results : defaultDatas),
                    }]
                };
    
                const config = {
                    type: 'line',
                    data,
                    options: {}
                };
                stat.InitChart('project_chart', config);
            });
        }
    },

    CommandChart : () => {

        // FACTURATION
        if (J('#command_stat').length) {

            let queryYear = J('#command_stat').attr('query-year');
            if (queryYear && queryYear != 'all') {
                queryYear = parseInt(queryYear);

                const labels = stat.MonthLabel();
                let defaultDatas = [5, 10, 60, 30, 20, 10, 80, 30, 50, 90, 60, 30];

                stat.Ajax('/admin/ajax/stat/commands?year='+queryYear, {}, function(results) {

                    let commands = [];
                    let stt = [];
                    let marge = [];
                    let minimum_month_amount = [];

                    if (results) {

                        commands = results.commands.length ? results.commands : [];
                        stt = results.stt.length ? results.stt : [];
                        marge = results.marge.length ? results.marge : [];
                        minimum_month_amount = results.minimum_month_amount.length ? results.minimum_month_amount : [];

                        if (commands.length) {

                            for (var i=0; i < commands.length; i++) {
                                let month_number = i + 1;
                                if (J('.chart-table-list-item[month-number="'+month_number+'"]').length) {

                                    let value = commands[i].toFixed(0);
                                        value = parseFloat(value);
                                        value = value.toLocaleString();
                                    J('.chart-table-list-item[month-number="'+month_number+'"]')
                                        .children('.chart-table-list-item-value')
                                        .attr('data-value', commands[i])
                                        .text( value+'€' )
                                    ;

                                }
                            }
                        }

                        if (stt.length) {

                            for (var i=0; i < stt.length; i++) {
                                let month_number = i + 1;
                                if (J('.chart-table-list-item[month-number="'+month_number+'"]').length) {

                                    let data_value = J('.chart-table-list-item[month-number="'+month_number+'"]').children('.chart-table-list-item-value').attr('data-value');
                                        data_value = parseFloat(data_value);

                                    let stt_value = stt[i].toFixed(0);
                                        stt_value = parseFloat(stt_value);
                                        stt_value = stt_value.toLocaleString();
                                    J('.chart-table-list-item[month-number="'+month_number+'"]').children('.chart-table-list-item-stt').text( stt_value+'€' );

                                    let diff_value = data_value - stt[i];
                                        diff_value = diff_value.toFixed(0);
                                        diff_value = parseFloat(diff_value);
                                        diff_value = diff_value.toLocaleString();

                                    J('.chart-table-list-item[month-number="'+month_number+'"]').children('.chart-table-list-item-diff').text( diff_value+'€' );
                                }
                            }
                        }

                        const data = {
                            labels: labels,
                            datasets: [
                                {
                                    label: 'Commandes '+queryYear,
                                    backgroundColor: [
                                        'rgba(255, 99, 132, 0.2)',
                                        'rgba(255, 159, 64, 0.2)',
                                        'rgba(255, 205, 86, 0.2)',
                                        'rgba(75, 192, 192, 0.2)',
                                        'rgba(54, 162, 235, 0.2)',
                                        'rgba(153, 102, 255, 0.2)',
                                        'rgba(201, 203, 207, 0.2)',
                                        'rgba(255, 159, 64, 0.2)',
                                        'rgba(54, 162, 235, 0.2)',
                                        'rgba(255, 99, 132, 0.2)',
                                        'rgba(75, 192, 192, 0.2)',
                                        'rgba(201, 203, 207, 0.2)',
                                    ],
                                    borderColor: [
                                        'rgb(255, 99, 132)',
                                        'rgb(255, 159, 64)',
                                        'rgb(255, 205, 86)',
                                        'rgb(75, 192, 192)',
                                        'rgb(54, 162, 235)',
                                        'rgb(153, 102, 255)',
                                        'rgb(201, 203, 207)',
                                        'rgb(255, 159, 64)',
                                        'rgb(54, 162, 235)',
                                        'rgb(255, 99, 132)',
                                        'rgb(75, 192, 192)',
                                        'rgb(201, 203, 207)',
                                    ],
                                    data: (commands ? commands : defaultDatas),
                                    borderWidth: 1,
                                },
                                {
                                    label: 'Montant sous-traitant',
                                    backgroundColor: [
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                    ],
                                    borderColor: [
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                    ],
                                    data: (stt ? stt : defaultDatas),
                                    borderWidth: 1,
                                },
                                {
                                    label: 'Marge',
                                    backgroundColor: [
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                    ],
                                    borderColor: [
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                    ],
                                    data: (marge ? marge : defaultDatas),
                                    borderWidth: 1,
                                },
                                {
                                    label: 'Chiffre minimum mensuel',
                                    data: minimum_month_amount,
                                    borderColor: 'rgb(199, 0, 0)',
                                    fill: false,
                                    backgroundColor: 'rgb(199, 0, 0)',
                                    type: 'line',
                                    order: 0
                                }
                            ]
                        };
                        const config = {
                            type: 'bar',
                            data,
                            options: {}
                        };
                        stat.InitChart('command_stat', config);
                    }
                });
            }
        }

    },

    InvoiceChart : () => {

        // FACTURATION
        if (J('#invoice_stat').length) {

            let queryYear = J('#invoice_stat').attr('query-year');
            if (queryYear && queryYear != 'all') {
                queryYear = parseInt(queryYear);

                const labels = stat.MonthLabel();
                let defaultDatas = [5, 10, 60, 30, 20, 10, 80, 30, 50, 90, 60, 30];

                stat.Ajax('/admin/ajax/stat/invoices?year='+queryYear, {}, function(results) {

                    let invoices = [];
                    let stt = [];
                    let marge = [];
                    let minimum_month_amount = [];

                    if (results) {

                        invoices = results.invoices.length ? results.invoices : [];
                        stt = results.stt.length ? results.stt : [];
                        marge = results.marge.length ? results.marge : [];
                        minimum_month_amount = results.minimum_month_amount.length ? results.minimum_month_amount : [];

                        if (invoices.length) {

                            for (var i=0; i < invoices.length; i++) {
                                let month_number = i + 1;
                                if (J('.chart-table-list-item[month-number="'+month_number+'"]').length) {

                                    let value = invoices[i].toFixed(0);
                                        value = parseFloat(value);
                                        value = value.toLocaleString();
                                    J('.chart-table-list-item[month-number="'+month_number+'"]')
                                        .children('.chart-table-list-item-value')
                                        .attr('data-value', invoices[i])
                                        .text( value+'€' )
                                    ;

                                }
                            }
                        }

                        if (stt.length) {

                            for (var i=0; i < stt.length; i++) {
                                let month_number = i + 1;
                                if (J('.chart-table-list-item[month-number="'+month_number+'"]').length) {

                                    let data_value = J('.chart-table-list-item[month-number="'+month_number+'"]').children('.chart-table-list-item-value').attr('data-value');
                                        data_value = parseFloat(data_value);

                                    let stt_value = stt[i].toFixed(0);
                                        stt_value = parseFloat(stt_value);
                                        stt_value = stt_value.toLocaleString();
                                    J('.chart-table-list-item[month-number="'+month_number+'"]').children('.chart-table-list-item-stt').text( stt_value+'€' );

                                    let diff_value = data_value - stt[i];
                                        diff_value = diff_value.toFixed(0);
                                        diff_value = parseFloat(diff_value);
                                        diff_value = diff_value.toLocaleString();

                                    J('.chart-table-list-item[month-number="'+month_number+'"]').children('.chart-table-list-item-diff').text( diff_value+'€' );
                                }
                            }
                        }

                        const data = {
                            labels: labels,
                            datasets: [
                                {
                                    label: 'Factures '+queryYear,
                                    backgroundColor: [
                                        'rgba(255, 99, 132, 0.2)',
                                        'rgba(255, 159, 64, 0.2)',
                                        'rgba(255, 205, 86, 0.2)',
                                        'rgba(75, 192, 192, 0.2)',
                                        'rgba(54, 162, 235, 0.2)',
                                        'rgba(153, 102, 255, 0.2)',
                                        'rgba(201, 203, 207, 0.2)',
                                        'rgba(255, 159, 64, 0.2)',
                                        'rgba(54, 162, 235, 0.2)',
                                        'rgba(255, 99, 132, 0.2)',
                                        'rgba(75, 192, 192, 0.2)',
                                        'rgba(201, 203, 207, 0.2)',
                                    ],
                                    borderColor: [
                                        'rgb(255, 99, 132)',
                                        'rgb(255, 159, 64)',
                                        'rgb(255, 205, 86)',
                                        'rgb(75, 192, 192)',
                                        'rgb(54, 162, 235)',
                                        'rgb(153, 102, 255)',
                                        'rgb(201, 203, 207)',
                                        'rgb(255, 159, 64)',
                                        'rgb(54, 162, 235)',
                                        'rgb(255, 99, 132)',
                                        'rgb(75, 192, 192)',
                                        'rgb(201, 203, 207)',
                                    ],
                                    data: (invoices ? invoices : defaultDatas),
                                    borderWidth: 1,
                                },
                                {
                                    label: 'Montant sous-traitant',
                                    backgroundColor: [
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                    ],
                                    borderColor: [
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                        'rgba(233, 162, 68, 0.9)',
                                    ],
                                    data: (stt ? stt : defaultDatas),
                                    borderWidth: 1,
                                },
                                {
                                    label: 'Marge',
                                    backgroundColor: [
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                        'rgba(0, 0, 0, 0.1)',
                                    ],
                                    borderColor: [
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                        'rgba(45, 101, 185, 0.9)',
                                    ],
                                    data: (marge ? marge : defaultDatas),
                                    borderWidth: 1,
                                },
                                {
                                    label: 'Chiffre minimum mensuel',
                                    data: minimum_month_amount,
                                    borderColor: 'rgb(199, 0, 0)',
                                    fill: false,
                                    backgroundColor: 'rgb(199, 0, 0)',
                                    type: 'line',
                                    order: 0
                                }
                            ]
                        };
                        const config = {
                            type: 'bar',
                            data,
                            options: {}
                        };
                        stat.InitChart('invoice_stat', config);
                    }
                });
            }
        }

    },

    InvoiceMonth : () => {

        if (J('#widget_invoice_month').length) {

            stat.Ajax('/admin/ajax/stat/invoices/month?year='+stat.QueryYear, {}, function(results) {

                if (results) {
                    for (var i=0; i < results.length; i++) {
                        if (J('.invoice-month-value').eq(i).length) {
                            let value = results[i].toFixed(2);
                                value = parseFloat(value);
                                value = value.toLocaleString();
                            J('.invoice-month-value').eq(i).text( value+'€' );
                        } 
                    }
                }
            });
        }
    },

    TurnOverChar : () => {
        // FACTURATION
        if (J('#turnover_chart').length) {

            const labels = stat.MonthLabel();
            let defaultDatas = [5, 10, 60, 30, 20, 10, 80, 30, 50, 90, 60, 30];

            stat.Ajax('/admin/ajax/stat/numbers?year='+stat.QueryYear, {}, function(results) {

                if (results) {
                    for (var i=0; i < results.length; i++) {
                        if (J('.turn-over-data').eq(i).length) {
                            let value = results[i].toFixed(2);
                                value = parseFloat(value);
                                value = value.toLocaleString();
                            J('.turn-over-data').eq(i).text( value+'€' );
                        } 
                    }
                }

                const data = {
                    labels: labels,
                    datasets: [{
                        label: 'Facturation mensuelle '+stat.QueryYear,
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.2)',
                            'rgba(255, 159, 64, 0.2)',
                            'rgba(255, 205, 86, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(153, 102, 255, 0.2)',
                            'rgba(201, 203, 207, 0.2)',
                            'rgba(255, 159, 64, 0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(255, 99, 132, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(201, 203, 207, 0.2)',
                        ],
                        borderColor: [
                            'rgb(255, 99, 132)',
                            'rgb(255, 159, 64)',
                            'rgb(255, 205, 86)',
                            'rgb(75, 192, 192)',
                            'rgb(54, 162, 235)',
                            'rgb(153, 102, 255)',
                            'rgb(201, 203, 207)',
                            'rgb(255, 159, 64)',
                            'rgb(54, 162, 235)',
                            'rgb(255, 99, 132)',
                            'rgb(75, 192, 192)',
                            'rgb(201, 203, 207)',
                        ],
                        data: (results ? results : defaultDatas),
                        borderWidth: 1,
                    }]
                };
                const config = {
                    type: 'bar',
                    data,
                    options: {}
                };
                stat.InitChart('turnover_chart', config);
            });
        }
    },

    QuotationChart : () => {
        // DEVIS
        if (J('#quotation_chart').length) {

            const labels        = stat.MonthLabel();
            let defaultDatas    = [42, 10, 60, 30, 20, 10, 80, 30, 50, 90, 60, 65];

            stat.Ajax('/admin/ajax/stat/quotations?year='+stat.QueryYear, {}, function(results){

                const data = {
                    labels: labels,
                    datasets: [{
                        label: 'Devis',
                        backgroundColor: 'rgb(255, 99, 132)',
                        borderColor: 'rgb(255, 99, 132)',
                        data: (results ? results : defaultDatas),
                    }]
                };
                const config = {
                    type: 'line',
                    data,
                    options: {}
                };
                stat.InitChart('quotation_chart', config);
            });
        }

        if (J('#quotation_stat').length) {

            let queryYear = J('#quotation_stat').attr('query-year');
            if (queryYear && queryYear != 'all') {
                queryYear = parseInt(queryYear);

                const labels = stat.MonthLabel();
                let defaultDatas = [5, 10, 60, 30, 20, 10, 80, 30, 50, 90, 60, 30];

                stat.Ajax('/admin/ajax/stat/quotations?year='+queryYear, {}, function(results) {

                    let quotations = [];
                    let minimum_month_amount = [];

                    if (results) {

                        quotations = results.quotations.length ? results.quotations : [];
                        minimum_month_amount = results.minimum_month_amount.length ? results.minimum_month_amount : [];

                        if (quotations.length) {


                            for (var i=0; i < quotations.length; i++) {
                                let month_number = i + 1;
                                if (J('.chart-table-list-item[month-number="'+month_number+'"]').length) {

                                    let value = quotations[i].toFixed(0);
                                        value = parseFloat(value);
                                        value = value.toLocaleString();
                                    J('.chart-table-list-item[month-number="'+month_number+'"]').children('.chart-table-list-item-value').text( value+'€' );

                                }
                            }
                        }

                        const data = {
                            labels: labels,
                            datasets: [
                                {
                                    label: 'Devis '+queryYear,
                                    backgroundColor: [
                                        'rgba(255, 99, 132, 0.2)',
                                        'rgba(255, 159, 64, 0.2)',
                                        'rgba(255, 205, 86, 0.2)',
                                        'rgba(75, 192, 192, 0.2)',
                                        'rgba(54, 162, 235, 0.2)',
                                        'rgba(153, 102, 255, 0.2)',
                                        'rgba(201, 203, 207, 0.2)',
                                        'rgba(255, 159, 64, 0.2)',
                                        'rgba(54, 162, 235, 0.2)',
                                        'rgba(255, 99, 132, 0.2)',
                                        'rgba(75, 192, 192, 0.2)',
                                        'rgba(201, 203, 207, 0.2)',
                                    ],
                                    borderColor: [
                                        'rgb(255, 99, 132)',
                                        'rgb(255, 159, 64)',
                                        'rgb(255, 205, 86)',
                                        'rgb(75, 192, 192)',
                                        'rgb(54, 162, 235)',
                                        'rgb(153, 102, 255)',
                                        'rgb(201, 203, 207)',
                                        'rgb(255, 159, 64)',
                                        'rgb(54, 162, 235)',
                                        'rgb(255, 99, 132)',
                                        'rgb(75, 192, 192)',
                                        'rgb(201, 203, 207)',
                                    ],
                                    data: (quotations ? quotations : defaultDatas),
                                    borderWidth: 1,
                                },
                                {
                                    label: 'Chiffre minimum mensuel',
                                    data: minimum_month_amount,
                                    borderColor: 'rgb(199, 0, 0)',
                                    fill: false,
                                    backgroundColor: 'rgb(199, 0, 0)',
                                    type: 'line',
                                    order: 0
                                }
                            ]
                        };
                        const config = {
                            type: 'bar',
                            data,
                            options: {}
                        };
                        stat.InitChart('quotation_stat', config);
                    }
                });
            }
        }
    },

    InitChart : (elementId, config) => {

        let Chart = require('chart.js/dist/chart');

        new Chart(
            document.getElementById(elementId),
            config
        );
    },

    Ajax : (url, data = {}, callback) => {

        let Ajax = J.ajax({
            url : url,
            method: 'POST',
            dataType : 'JSON',
            data: data
        });
        Ajax.done(function(result){
            return callback(result);
        });
        Ajax.fail(function(error){
            return callback(error);
        });
    }
}
module.exports = stat;